export default {
    SOCIAL_AUTH_FAILED: "Unauthorized for social feature access.",
    SOCIAL_FETCH_INFO_FAILED: "Sorry!, Unable to fetch your social information."
}